import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import {Tooltip as ReactTooltip} from 'react-tooltip';

export const Tooltip = ({id, title}) => {
  const tooltipRef = useRef();

  const getAnchor = () => (
    <a
      data-tooltip-id={id}
      href={`/glossary/${id}`}
      /*
       * Imitate the click on tooltip title,
       * so that tooltip hides away when its clicked inside the tooltip
       */
      onClick={() => tooltipRef.current?.click()}
      rel='noreferrer'
      target='_blank'
    >
      View Definition
    </a>
  );

  return (
    <>
      <span
        className='tooltip-content'
        data-tooltip-content={title}
        data-tooltip-id={id}
        ref={tooltipRef}
      >
        {title}
      </span>
      <ReactTooltip
        className='react-tooltip-clickable-link shadow'
        clickable
        closeEvents={['click']}
        delayHide={1}
        globalCloseEvents={['clickOutsideAnchor']}
        id={id}
        openOnClick
        render={() => getAnchor()}
        wrapper='span'
      />
    </>
  );
};

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
